import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { DirectivesModule } from '../../directives/directives.module';
import { MatFormFieldModule, MatTableModule, MatPaginatorModule, MatSortModule, MatInputModule, MatCheckboxModule, MatButtonModule, MatIconModule, MatDatepickerModule, MatSelectModule, MatOptionModule } from '@angular/material';
import { ReportPatientDetailsPage } from './report-patient-details';

@NgModule({
  declarations: [
    ReportPatientDetailsPage
  ],
  imports: [
    IonicPageModule.forChild(ReportPatientDetailsPage),
    MatFormFieldModule, MatTableModule, MatPaginatorModule, MatSortModule, MatInputModule, MatCheckboxModule, MatButtonModule, MatIconModule, MatDatepickerModule, MatSelectModule, MatOptionModule,
    DirectivesModule
  ],
})
export class ReportPatientDetailsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/report-patient-details/report-patient-details.module.ts